import { render } from "./ColorSchemeSelect.vue?vue&type=template&id=5bb25f10&ts=true"
import script from "./ColorSchemeSelect.vue?vue&type=script&lang=ts"
export * from "./ColorSchemeSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__